export default __webpack_public_path__ + "static/media/loader.c05f78cd.gif";